<template>
  <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`">
    <g :transform="`rotate(-90 ${size / 2} ${size / 2})`">
      <circle
        v-for="(seg, i) in segments"
        :key="i"
        :cx="size / 2"
        :cy="size / 2"
        :r="radius"
        fill="none"
        :stroke="seg.color"
        :stroke-width="stroke"
        :stroke-dasharray="`${seg.len} ${circ - seg.len}`"
        :stroke-dashoffset="-seg.off"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "DonutChart",
  props: {
    // [{ name, value, color }]
    data: { type: Array, default: () => [] },
    size: { type: Number, default: 170 },
    stroke: { type: Number, default: 28 },
  },
  computed: {
    radius() {
      return (this.size - this.stroke) / 2;
    },
    circ() {
      return 2 * Math.PI * this.radius;
    },
    total() {
      return this.data.reduce((a, b) => a + b.value, 0) || 1;
    },
    segments() {
      let off = 0;
      return this.data.map((d) => {
        const len = (this.circ * d.value) / this.total;
        const seg = { color: d.color, len, off };
        off += len;
        return seg;
      });
    },
  },
};
</script>
